/**
 * Runtime configuration compiled at build time
 * Webpack aliases resolve to the correct environment file based on BUILD_ENV
 */

// Import the environment configuration - webpack will resolve this based on alias
// The alias points to environment.staging.ts when BUILD_ENV=staging
// or environment.prod.ts when BUILD_ENV=production
// @ts-ignore
import { environment } from '../environments/environment';

interface RuntimeConfig {
  apiUrl: string;
  environment: 'development' | 'staging' | 'production';
  version: string;
}

// Build the runtime configuration from the compiled environment
// Note: This is compiled at build time by webpack, not at runtime
export const getRuntimeConfig = (): RuntimeConfig => {
  return {
    apiUrl: environment.apiUrl,
    environment: environment.production
      ? ((environment as any).staging ? 'staging' : 'production')
      : 'development',
    version: environment.version
  };
};

export const config = getRuntimeConfig();